import { CommonUtility } from '../common';
import { APIPath } from '../constants';
import { BaseService } from './base';
import { CRUDService } from './crud.ts';

class Allocation extends CRUDService {
  constructor() {
    super(APIPath.allocation);
  }

  removeAllocation(waveId, allocationId) {
    const url = `${APIPath.orderWaves}/${waveId}/allocations/${allocationId}/remove`;
    return BaseService.post(url);
  }

  cancelAllocation(allocationId) {
    const url = `${APIPath.orderAllocations}/${allocationId}/cancel`;
    return BaseService.post(url);
  }

  cancelAllocations(allocationIds) {
    return BaseService.post(APIPath.orderAllocationsCancel, { allocationIds });
  }

  getAllocations(params) {
    const url = `${APIPath.orderAllocations}/?${CommonUtility.objectToParams(params)}`;
    return BaseService.get(url);
  }

  assignAllocationToWave(waveId, allocationId, data) {
    const url = `${APIPath.orderWaves}/${waveId}/allocations/${allocationId}/add`;
    return BaseService.post(url, data);
  }

  listLocation(id, params) {
    return BaseService.get(
      `${
        APIPath.orderAllocations
      }/${id}/listAvailableInventoryLocations/?${CommonUtility.objectToParams(params)}`,
    );
  }

  changeAllocation(id, data) {
    return BaseService.post(
      `${APIPath.orderAllocations}/${id}/moveAllocationLocation`,
      data,
    );
  }

  removeAllocationFromContainer(id) {
    return BaseService.post(`${APIPath.orderAllocations}/${id}/removeFromContainer`);
  }

  getAllocationsLocation(data) {
    return BaseService.post(APIPath.orderAllocationsPickingLocationSuggestions, data);
  }

  moveBulkAllocations(data) {
    return BaseService.post(APIPath.orderAllocationsMoveLocationBatch, data);
  }

  refreshUnassignedAllocations(data) {
    return BaseService.post(APIPath.orderAllocationsUnassignedRefresh, data);
  }

  getUnassignedAllocationRefreshStatus(params) {
    const url = `${APIPath.orderAllocationsUnassignedRefreshStatus}?${CommonUtility.objectToParams(
      params,
    )}`;
    return BaseService.get(url);
  }

  createUnassignedBatchTransfer(data) {
    return BaseService.post(APIPath.orderAllocationsUnassignedBatchTransfer, data);
  }
}

const AllocationService = new Allocation();
Object.freeze(AllocationService);
export { AllocationService };
